module.exports = __webpack_public_path__ + "img/62.46dd3262.jpg";